import { ClipboardEvent, useCallback, useEffect, useRef, useState } from 'react';

const AUTO_DISMISS_MS = 6000;

// Blocks paste (anti-cheat) and surfaces a friendly notice explaining why.
export const usePasteBlockedNotification = (isPasteAllowed: boolean) => {
  const [isNoticeVisible, setIsNoticeVisible] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const dismissNotice = useCallback(() => setIsNoticeVisible(false), []);

  const handlePaste = useCallback(
    (event: ClipboardEvent<HTMLTextAreaElement>) => {
      if (isPasteAllowed) return;
      event.preventDefault();
      setIsNoticeVisible(true);
    },
    [isPasteAllowed]
  );

  useEffect(() => {
    if (!isNoticeVisible) return undefined;
    timeoutRef.current = setTimeout(dismissNotice, AUTO_DISMISS_MS);
    return () => clearTimeout(timeoutRef.current);
  }, [isNoticeVisible, dismissNotice]);

  return { isNoticeVisible, handlePaste, dismissNotice };
};
